import React from 'react'
import MyProfile from './MyProfile'
import MyComanies from './MyCompanies'
import { Message } from '../locale/Message'
import { connect } from 'react-redux'

const MY_PROFILE = 'MY_PROFILE'
const MY_COMPANY = 'MY_COMPANY'

class Settings extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      page: MY_COMPANY
    }
  }

  renderPage() {
    switch (this.state.page) {
      case MY_PROFILE:
        return <MyProfile />
      case MY_COMPANY:
        return <MyComanies />
    }
  }

  changePage = (event) => {
    this.setState({ page: event.target.name })
    event.preventDefault()
  }

  render() {
    const { page } = this.state
    const { lang } = this.props
    return (
      <div>
        <div className="submenu bg-white">
          <ul className="main-tabs list-unstyled d-xl-flex align-content-xl-center mb-0">
            <li className="">
              <a
                className={page === MY_PROFILE && 'active pr-5' || ''}
                href="#"
                name={MY_PROFILE}
                onClick={this.changePage}
              >{Message.myProfile[lang]}</a>
            </li>
            <li className="">
              <a
                className={page === MY_COMPANY && 'active pl-5' || ''}
                href="#"
                name={MY_COMPANY}
                onClick={this.changePage}
              >{Message.myCompanies[lang]}</a>
            </li>
          </ul>
        </div>
        {this.renderPage()}
      </div>
    )
  }

}

export default connect(
  (state) => ({
    lang: state.lang
  }))(Settings)